<template>
    <div :id="getId(params)">
        <span >
            {{ params.value }}
        </span>
        <b-tooltip class="primary" :target="getId(params)" placement="right">
            <b-card
                    bg-variant="primary"
                    text-variant="white"
                    :header="params.colDef.headerName"
                    >
                <p class="card-text">{{ params.value }}</p>
            </b-card>
        </b-tooltip>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    getId(params) {
      if (params.data && params.data.reportId) {
        return `tooltip-${params.data.reportId}-${params.colDef.field}`;
      }
      const key = (params.data) ? params.data.clientActionId : 'group-header';
      return `tooltip-${key}-${params.colDef.field}`;
    },
  },
});
</script>

<style lang="scss">
.tooltip-inner {
    padding: 0;
    max-width: 600px;
    text-align: left;
}

.tooltip {
    .arrow:before {
        border-right-color: $primary;
        border-left-color: $primary;
    }
}
</style>
